module.exports = __webpack_public_path__ + "img/banner-dark.4d4ebd02.svg";